import VideoParticipant from "./VideoParticipant";

export default VideoParticipant;
